/**
 * @generated SignedSource<<ed688cbd7d1cb4d073923428ade8e5cb>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type Metric_metric$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Metrics_pipeline$fragmentType: FragmentType;
export type Metrics_pipeline$data = {|
  +metrics: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +label: string,
        +$fragmentSpreads: Metric_metric$fragmentType,
      |},
    |}>,
  |},
  +$fragmentType: Metrics_pipeline$fragmentType,
|};
export type Metrics_pipeline$key = {
  +$data?: Metrics_pipeline$data,
  +$fragmentSpreads: Metrics_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Metrics_pipeline",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 6
        }
      ],
      "concreteType": "PipelineMetricConnection",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PipelineMetricEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PipelineMetric",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Metric_metric"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "metrics(first:6)"
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};

(node/*: any*/).hash = "671b5cf743fc3592b40912b4721de9e0";

module.exports = ((node/*: any*/)/*: Fragment<
  Metrics_pipeline$fragmentType,
  Metrics_pipeline$data,
>*/);
